import { useState } from "react";
import { Box as MuiBox, Typography as MuiTypography } from "@mui/material";
import { FilterPanel } from "app/shared/ui/FilterPanel/FilterPanel";

export const Page = ({ title = "", filter = null, main }) => {
  const [open, setOpen] = useState(true);

  function handleDrawerToggle() {
    setOpen(!open);
  }

  return (
    <MuiBox
      id="pageContainer"
      sx={{
        gap: "16px",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "row",
      }}
    >
      {filter && (
        <MuiBox>
          <FilterPanel open={open} handleDrawerToggle={handleDrawerToggle}>
            {filter}
          </FilterPanel>
        </MuiBox>
      )}
      <MuiBox
        id="pageContent"
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          marginTop: "16px",
          marginBottom: "16px",
          flexDirection: "column",
        }}
      >
        <MuiBox id="pageHeader">
          {title && <MuiTypography variant="h1">{title}</MuiTypography>}
        </MuiBox>
        <MuiBox id="pageMain">{main}</MuiBox>
      </MuiBox>
    </MuiBox>
  );
};
